module.exports = __webpack_public_path__ + "img/ctrl-cross-resonance-stub-mid-+i.1dc83db0.svg";